const companies = [
  { id: "OSM", label: "Osmium" },
  { id: "ACC", label: "Accilema" },
];

export default companies;
